import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SignalSection } from '../components/SignalSection';
import { ProductReveal } from '../components/ProductReveal';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { ResultsSection } from '../components/ResultsSection';
import { PricingCTA } from '../components/PricingCTA';
import { ReviewsCarousel } from '../components/ReviewsCarousel';
import { MatrixRain } from '../components/MatrixRain';
import { RecentPurchasePopup } from '../components/RecentPurchasePopup';
import { Footer } from '../components/Footer';
import { MarqueeBanner } from '../components/MarqueeBanner';
export function SalesPage() {
  return <main className="min-h-screen bg-matrix-bg text-matrix-text selection:bg-matrix-primary selection:text-matrix-bg relative" data-id="element-412">
      {/* Full-page Matrix Rain background */}
      <MatrixRain data-id="element-413" />

      {/* Social proof popup */}
      <RecentPurchasePopup data-id="element-414" />

      <div className="relative z-10" data-id="element-415">
        {/* Scrolling offer banner */}
        <MarqueeBanner data-id="element-416" />

        <HeroSection data-id="element-417" />
        <ProblemSection data-id="element-418" />
        <SignalSection data-id="element-419" />
        <ProductReveal data-id="element-420" />
        <WhyFailedSection data-id="element-421" />
        <IncludesSection data-id="element-422" />
        <ForWhoSection data-id="element-423" />
        <ResultsSection data-id="element-424" />
        <PricingCTA data-id="element-425" />
        <ReviewsCarousel data-id="element-426" />

        <Footer data-id="element-427" />
      </div>
    </main>;
}